var render, staticRenderFns
import script from "./DiscussionList.vue?vue&type=script&lang=js"
export * from "./DiscussionList.vue?vue&type=script&lang=js"
import style0 from "./DiscussionList.vue?vue&type=style&index=0&id=292fb3cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292fb3cf",
  null
  
)

export default component.exports